import { render } from "./UploadMultipleFiles.vue?vue&type=template&id=2b3eba42&scoped=true"
import script from "./UploadMultipleFiles.vue?vue&type=script&lang=js"
export * from "./UploadMultipleFiles.vue?vue&type=script&lang=js"

import "./UploadMultipleFiles.vue?vue&type=style&index=0&id=2b3eba42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3eba42"]])

export default __exports__